<template>
<div class="faqscontainer">
   <v-card>
 <v-card-text >
          <transition name="slide-fade">   
                <v-row>
                   <v-col cols="12" sm="12" md="12" offset-md="0">
                    <h2>Refund</h2>
                    </v-col>
                  <v-col cols="12" sm="12" md="12" offset-md="0">
                          <v-card color="whitebackground">
                            <template>
  <v-simple-table dark>
    <template v-slot:default>
      <thead>
        <tr>
          <th style="text-align:center" class="text-left">
            Sno.
          </th>
           <th class="text-left" style="text-align:center">
            Banner Title
          </th>
           <th class="text-left" style="text-align:center">
            Amount
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in desserts"
          :key="item.name"
        >
          <td style="text-align:left">{{ item.sno }}</td>
          <td style="text-align:left">{{ item.bannertitle }}</td>
          <td style="text-align:left">{{ item.amount }}</td>
        </tr>
        <tr>
          <td style="text-align:right" colspan="2">Total Amount</td> 
          <td style="text-align:left">AUD 100 </td> 
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
                            
                              
                          </v-card> 
                        </v-col> 
                </v-row>  
          </transition>
    </v-card-text> 
  </v-card>
 </div>     
</template>
<script>
  export default {
    data () {
      return {
        desserts: [
          {
            sno: 1,
            bannertitle: 'Wipro Pvt. Ltd',
            amount: 'AUD 50',
           
          },
          {
            sno: 2,
            bannertitle: 'Infosys',
            amount: 'AUD 50',
          },
          
        ],
      }
    },
  }
</script>
<style scoped>
.container.fill-height > .row { max-width: initial;}
.faqscontainer{width:80%;text-align: center;margin:20px auto;}
.outercls{overflow-y:scroll;height: 450px;}
</style>